import React, {useEffect} from "react";
import SelectField from "../SelectField";

const LogMessageSelectField = ({disabled = false, onChange = null, onEnter = null, name = "message"}) => {

    let data = [
        {label: "Úspěšný vchod", value: "ENTRY_SUCCESS"},
        {label: "Úspěšný východ", value: "EXIT_SUCCESS"},
        {label: "Úspěšný průchod v areálu", value: "ENTRY_IN_AREA"},
        {label: "Vstupenka nenalezena", value: "NOT_FOUND"},
        {label: "Již vstoupil", value: "IN_ZONE"},
        {label: "Ještě nevstoupil", value: "NOT_IN_ZONE"},
        {label: "Vstupenka vyčerpána", value: "CARD_USED"},
        {label: "Špatná zóna", value: "INCORRECT_ZONE"},
        {label: "Neznámý turniket", value: "UNKNOWN_TURNSTILE"},
        {label: "Není v nadřazené zóně", value: "NOT_IN_PARENT_ZONE"},
        {label: "Plná kapacita", value: "FULL_CAPACITY"},
        {label: "OK", value: "OK"},
        {label: "Blokace vstupenky OK", value: "TICKET_BLOCATION_OK"},
        {label: "Vstupenka nemá blokaci", value: "NO_TICKET_ENTRANCE_BLOCATION"},
        {label: "Průchod blokován", value: "TICKET_ENTRANCE_BLOCKED"},
        {label: "Nedostatek kreditu", value: "NO_CREDIT"},
        {label: "Čtení blokováno", value: "READING_BLOCKED"},
        {label: "Obličej nerozeznán", value: "FACE_NOT_RECOGNIZED"},
        {label: "Načtení obrázku OK", value: "IMAGE_GET_SUCCESS"},
        {label: "Neznámý", value: "UNKNOWN"},
    ];

    return (
        <SelectField onEnter={onEnter} onChange={onChange} disabled={disabled} placeholder={"Výsledek"} name={name}
                     options={data} label={"Výsledek"} isMulti={true}/>
    )
}

export default LogMessageSelectField;
